import Vue from 'vue'
import PuzzleVerification from 'vue-puzzle-verification'
Vue.use(PuzzleVerification)
export default PuzzleVerification